import React from "react";
import { useUser } from "@webuild-ai/react-auth";

import { PageTitle } from "@/components/UI/PageTitle";

import { AppearanceSettings } from "./AppearanceSettings";
import { ExportSettings } from "./ExportSettings";
import { PromptShortcutsSettings } from "./PromptShortcutsSettings";
import { AboutSettings } from "./AboutSettings";

export const SettingsPage: React.FC = () => {
  const { userProfile } = useUser();

  if (!userProfile) {
    throw new Error("User profile not found");
  }

  return (
    <div className="w-full p-4 space-y-8">
      <PageTitle
        centered
        dataId="settings-title"
        icon="solar:settings-outline"
        subtitle="Settings Description"
        title="Settings"
      />

      <AppearanceSettings />
      <ExportSettings />
      <PromptShortcutsSettings />
      <AboutSettings />
    </div>
  );
};
